import {Component, inject, OnInit} from '@angular/core';

import {appRoutes} from '@numizmat/constants';
import {environment} from "@numizmat/environments";
import {MetaTagService} from "@numizmat/services/common";

@Component({
    selector: 'nz-canceled-payment',
    imports: [],
    templateUrl: './canceled-payment.component.html',
    styleUrl: './canceled-payment.component.scss'
})
export class CanceledPaymentComponent implements OnInit {
  private metaTagService: MetaTagService = inject(MetaTagService);

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.setMetaTags();
  }

  private setMetaTags(): void {
    this.metaTagService.setCanonicalUrl(`${environment.applicationDomain}/${appRoutes.canceledPayment}`);
    this.metaTagService.setTitle('Неуспешно плащане | Collectoria');
    this.metaTagService.setDescription('Неуспешно плащане | Collectoria');
  }
}
